import { IOffer } from '../../repositories/chats/entities/get_my_offers_for_selection/Offer';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EOffersForSelectionTypes {
  SetOffersSelectionSucceed = 'OffersForSelection/SetOffersSelectionSucceed',
  SetOffersSelectionPending = 'OffersForSelection/SetOffersSelectionPending',
  SetOffersSelectionFailed = 'OffersForSelection/SetOffersSelectionFailed',
  SetOffersSelectionInitial = 'OffersForSelection/SetOffersSelectionInitial',
}

export interface ISetOffersForSelectionSucceedPayload {
  list: IOffer[];
  page?: number;
  totalCount?: number;
  canLoadMore?: boolean;
}

export type TOffersForSelectionActions =
  | ITypedReduxAction<EOffersForSelectionTypes.SetOffersSelectionSucceed, ISetOffersForSelectionSucceedPayload>
  | ITypedReduxAction<EOffersForSelectionTypes.SetOffersSelectionPending, void>
  | ITypedReduxAction<EOffersForSelectionTypes.SetOffersSelectionFailed, void>
  | ITypedReduxAction<EOffersForSelectionTypes.SetOffersSelectionInitial, void>;
